import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Flex, Grid, useColorModeValue } from '@chakra-ui/react';
import axios from 'axios';
import { useAuthHeader } from 'react-auth-kit';
import { FaBackspace } from 'react-icons/fa';
import Header from '../components/Header';
import BgCharged from '../assets/img/BgCharged.png';
import forta from '../assets/img/avatars/forta.png';
import TransactionInfo from '../components/Tables/components/TransactionInfo';
import TransactionInfoJson from '../components/Tables/components/TransactionInfoJson';
import TerminalObjectResultJson from '../components/Tables/components/TerminalObjectResultJson';
import TransactionLink from '../components/Tables/components/TransactionLink';

let OSH_ID = '';
const OSH_PROD_ID = 'e7206ef0-2a0c-11ed-bcc3-3fda638934f4';
const OSH_STAGE_ID = 'a4e5f230-d23b-11ed-9a7b-7fc90c5f04dd';
const OSH_DEV_ID = '9d09ec10-d23b-11ed-9a7b-7fc90c5f04dd';

const subdomain = window.location.hostname.split('.')[0];

switch (subdomain) {
  case 'prod':
    OSH_ID = OSH_PROD_ID;
    break;

  case 'stage':
    OSH_ID = OSH_STAGE_ID;
    break;

  default:
    OSH_ID = OSH_DEV_ID;
    break;
}

export function TerminalDetails(getAction) {
  const bgProfile = useColorModeValue(
    'hsla(0,0%,100%,.8)',
    'linear-gradient(112.83deg, rgba(255, 255, 255, 0.21) 0%, rgba(255, 255, 255, 0) 110.84%)'
  );
  const { id } = useParams();
  const token = useAuthHeader();
  const [action, setAction] = useState(false);
  const [notObjectResult, setNotObjectResult] = useState([]);
  const [objectResult, setObjectResult] = useState([]);
  const [partner, setPartner] = useState('');

  useEffect(() => {
    setAction(getAction);
  }, [getAction]);

  useEffect(() => {
    if (action) {
      let active = true;
      const getResult = async () => {
        if (active) {
          const newData = await fetchData(id, token());
          let data = Object.values(newData);
          let keys = Object.keys(newData);

          let obj = [];
          let notObj = {};
          for (let i = 0; i < data.length; ++i) {
            if (typeof data[i] === 'object') {
              if (data[i] !== null) {
                obj[keys[i]] = data[i];
              } else {
                notObj[keys[i]] = data[i];
              }
            } else {
              notObj[keys[i]] = data[i];
            }
          }

          setObjectResult(obj);
          setNotObjectResult(notObj);

          return () => {
            active = false;
          };
        }
      };
      getResult().then();
      return () => {
        active = false;
      };
    }
  }, [action]);

  useEffect(() => {
    if (action) {
      let active = true;
      const getPartner = async () => {
        if (active) {
          const merchant = await fetchPartner(
            notObjectResult.partner_id,
            token()
          );

          setPartner(merchant);
          return () => {
            active = false;
          };
        }
      };

      getPartner().then();
      return () => {
        active = false;
      };
    }
  }, [notObjectResult.id]);

  return (
    <Flex flexDirection="column" pt={{ base: '120px', md: '75px' }}>
      <Header
        BackUrl={'/admin_area/terminals'}
        backgroundHeader={BgCharged}
        backgroundProfile={bgProfile}
        avatarImage={forta}
        name={
          'Терминал ' + notObjectResult.id + ' (' + notObjectResult.type + ')'
        }
        isSubHeaderLink={true}
        subHeaderLink={`/admin_area/partners/${partner.id}/${partner.name}/${partner.login}`}
        email={[partner.name, '  (', partner.id, ')']}
        tabs={[
          {
            name: 'Back',
            icon: <FaBackspace w="100%" h="100%" />,
          },
        ]}
      />
      <Grid templateColumns={{ sm: '1fr', xl: 'repeat(1, 1fr)' }} gap="22px">
        {notObjectResult && (
          <TransactionInfo title={'info'} value={notObjectResult} />
        )}
        {objectResult &&
          Object.keys(objectResult).map((value, id) => {
            if (value === 'provider_params') {
              return (
                <TerminalObjectResultJson
                  key={id}
                  title={`${value}`}
                  value={objectResult[value]}
                  provider={notObjectResult.provider}
                  env={notObjectResult.env}
                  type={notObjectResult.type}
                />
              );
            } else {
              return (
                <TransactionInfoJson
                  key={id}
                  title={`${value}`}
                  value={objectResult[value]}
                />
              );
            }
          })}

        <TransactionLink
          title={'Transactions'}
          value={'Transactions'}
          link={`/admin_area/transactions?terminal=${notObjectResult.id}`}
        />

        <TransactionLink
          title={'Logs'}
          value={'Logs'}
          link={`https://osh.3ds.money/app/discover#/?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-24h,to:now))&_a=(columns:!(json.metadata.profile),filters:!(),index:'${OSH_ID}',interval:auto,query:(language:kuery,query:'%22terminal%20%3D%3E%20${notObjectResult.id}%22'),sort:!())`}
        />
      </Grid>
    </Flex>
  );

  async function fetchData(id = 1, token) {
    const response = await axios.get(`/api/v1/terminal/${id}`, {
      headers: { Authorization: token },
    });
    return await response.data;
  }

  async function fetchPartner(partnerId = 1, token) {
    const response = await axios.get(`/api/v1/profile/${partnerId}`, {
      headers: { Authorization: token },
    });
    return await response.data;
  }
}
